import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { DynamicToolUIPart, ToolUIPart } from 'ai';
import { Check } from 'lucide-react';
import RachelThinkingIndicator from '../RachelThinkingIndicator/RachelThinkingIndicator';
import ToolApprovalCard from './components/ToolApprovalCard';
import { useToolPart } from './useToolPart';

interface ToolPartProps {
  part: ToolUIPart | DynamicToolUIPart;
}

const ToolPart = ({ part }: ToolPartProps) => {
  const {
    toolName,
    isExpanded,
    approvalPrompt,
    handleAllow,
    handleAllowAlways,
    handleAllowAllChat,
    handleDecline,
  } = useToolPart(part);

  switch (part.state) {
    case 'input-streaming':
    case 'input-available':
    case 'approval-responded':
      return <RachelThinkingIndicator label={`${toolName}...`} />;
    case 'approval-requested':
      return (
        <ToolApprovalCard
          prompt={approvalPrompt}
          isExpanded={isExpanded}
          onAllow={handleAllow}
          onAllowAlways={handleAllowAlways}
          onAllowAllChat={handleAllowAllChat}
          onDecline={handleDecline}
        />
      );
    case 'output-available':
      return (
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          sx={(theme) => ({
            alignSelf: 'flex-start',
            py: 0.5,
            px: 1.25,
            borderRadius: `${theme.shape.borderRadius2xl}px`,
            backgroundColor: theme.palette.action.hover,
            color: theme.palette.success.main,
          })}
        >
          <Icon icon={Check} size="md" />
          <Typography variant="body2" color="text.primary">
            {toolName}
          </Typography>
        </Stack>
      );
    case 'output-error':
      return (
        <Typography variant="body2" color="error.main">
          {part.errorText}
        </Typography>
      );
    default:
      return null;
  }
};

export default ToolPart;
